module.exports = __webpack_public_path__ + "img/no-change-requests.3053ec5e.svg";